export default __webpack_public_path__ + "static/meet-the-team-slide-5-7bc8a812687e648e88e89e3d4ffa9d4d.jpg";